import { InboxUpsellRoot } from '../screens/inbox/components/upsell/InboxUpsellRoot';
import { ChatAction } from '../screens/labs/actions/ChatAction';
import { Grid, Text } from '@orthly/ui-primitives';
import React from 'react';

interface PracticeSidebarRightHeadlineProps {
    title: string;
    value?: string;
    ['data-test']?: string;
}

export const HeadlineItem: React.FC<PracticeSidebarRightHeadlineProps> = props => {
    return (
        <Grid container justifyContent={'space-between'} alignItems={'center'} data-test={props['data-test']}>
            <Text variant={'body2'} color={'DARK_GRAY'} style={{ fontWeight: 500 }}>
                {props.title}
            </Text>
            {props.value && (
                <Text variant={'h6'} color={'BLACK'}>
                    {props.value}
                </Text>
            )}
        </Grid>
    );
};

interface PracticeSidebarRightProps {
    topItems?: React.ReactNode;
    bottomItems?: React.ReactNode;
}

export const PracticeSidebarRight: React.FC<PracticeSidebarRightProps> = props => {
    return (
        <Grid container>
            <Grid item style={{ width: '100%' }}>
                {/* These items need to be in a container so they stayed grouped at the top */}
                {props.topItems}
            </Grid>
            <Grid item style={{ alignSelf: 'flex-end', width: '100%', marginBottom: '24px' }}>
                <InboxUpsellRoot />
                {props.bottomItems}
                <ChatAction />
            </Grid>
        </Grid>
    );
};
